module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-findUs"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("懂窝线下体验店"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝线下体验店根据加减乘除四大产品系列进行划分布置，每个空间都是一个个家的故事，"), _c('br'), _vm._v("通过富有温度的场景打造，营造出沉浸式家居购物体验。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module2"
  }, [_c('div', {
    staticClass: "swiper-container d-swiper1"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/swiper1-1.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/swiper1-2.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/swiper1-3.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/swiper1-4.png")
    }
  })])]), _c('div', {
    staticClass: "swiper-pagination"
  }), _c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("线上购物渠道"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("您不仅可以亲临懂窝体验店感受家的温度，"), _c('br'), _vm._v("还可以通过懂窝天猫店或懂窝微信小程序等线上渠道，"), _c('br'), _vm._v("轻松在线浏览懂窝产品，收获家居灵感及搭配方案，实现心目中家的样子。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module4"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("一键购买心仪好物")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("足不出户 体验便捷")]), _c('div', {
    staticClass: "code-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/img17.png")
    }
  }), _c('p', [_vm._v("扫码进入"), _c('br'), _vm._v(" 懂窝天猫店")]), _c('img', {
    attrs: {
      "src": require("assets/index/img18.png")
    }
  }), _c('p', [_vm._v("扫码进入"), _c('br'), _vm._v(" 懂窝小程序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module5"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("软装搭配服务"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("我们不仅提供设计、品质、性价比、功能和舒适度兼具的产品，"), _c('br'), _vm._v(" 还可根据客户需求提供量身定制的软装设计服务，帮您实现心目中家的样子。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module6"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝软装设计服务提供包含家具、床品/地毯、灯具、软装饰品、装饰画、墙面和窗帘等七项软装设计咨询及搭配服务。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("1.您可以与懂窝销售或客服联系，描绘您对家的期望与想象，我们将为您匹配专业设计师。"), _c('br'), _vm._v(" 2.设计师将与您进行深度沟通，挖掘您的设计需求，确定大致的设计方向。"), _c('br'), _vm._v(" 3并为您提供精心匹配的产品清单和量身定制的软装搭配方案，帮助您实现家的样子。")]), _c('div', {
    staticClass: "qr-code"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/img6.png")
    }
  }), _c('p', [_vm._v("扫码了解更多")])]), _c('img', {
    staticClass: "img",
    attrs: {
      "src": require("assets/findUs/img5.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module7"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户设计案例")]), _c('div', {
    staticClass: "swiper-container d-swiper2"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/swiper2-1.jpg")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/swiper2-3.jpg")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/swiper2-4.jpg")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/findUs/swiper2-6.jpg")
    }
  })])]), _c('div', {
    staticClass: "swiper-pagination"
  }), _c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30da343d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/findUs.vue
// module id = 440
// module chunks = 0